var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSentIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 43c1.66 0 3.21-.56 4.648-1.68l35.196-27.715C84.114 12.262 85 10.415 85 8.062c0-2.24-.775-4.143-2.324-5.71C81.126.784 79.245 0 77.03 0H7.97C5.755 0 3.874.784 2.324 2.352.774 3.919 0 5.822 0 8.062c0 2.352.885 4.2 2.656 5.543L37.852 41.32C39.29 42.44 40.84 43 42.5 43zm34.531 22c2.214 0 4.095-.78 5.645-2.342C84.226 61.097 85 59.201 85 56.971V19L50.303 46.265c-2.324 1.785-4.925 2.677-7.803 2.677s-5.479-.892-7.803-2.677L0 19v37.97c0 2.231.775 4.127 2.324 5.688C3.874 64.22 5.755 65 7.97 65H77.03z",
    fill: "#0074BD",
    fillRule: "nonzero"
  })));
}
export default SvgEmailSentIco;